<template>
  <div class="signin-signup">
    <div class="signin">
      <div class="title">
        <span>管理者ログイン</span>
      </div>
      <div class="form-table">
        <table>
          <tr>
            <th>メールアドレス：</th>
            <td><input type="email" v-model="signin_email"/></td>
          </tr>
          <tr>
            <th>パスワード：</th>
            <td><input type="password" v-model="signin_password"/></td>
          </tr>
        </table>
        <button class="signin-btn" @click="signin">ログイン</button>
      </div>
    </div>
  </div>
</template>

<script>
import { getAuth, signInWithEmailAndPassword } from "firebase/auth";

export default {
  data() {
    return {
      signin_email: '',
      signin_password: '',
    }
  },
  mounted() {
  },
  props: {
  },
  methods: {
    signin() {
      if (!this.signin_email) {
        alert("メールアドレスを入力してください");
        return;
      }
      if (!this.signin_password) {
        alert("パスワードを入力してください");
        return;
      }
      const auth = getAuth();
      signInWithEmailAndPassword( auth, this.signin_email, this.signin_password)
      .then((user) => {
        // 成功時の処理
        console.log(user);
        window.location.href = "/admin";
      })
      .catch((error) => {
        // エラー時の処理
        console.log(error);
        alert("ログインに失敗しました");
      });
    }
  }
}
</script>
<style scoped>
.signin-signup {
  margin-top: 2vw;
  display: inline-flex;
}
.signin {
  margin: 0 3vw;
  min-height: 30vw;
}
.title {
	text-align: left;
	font-size: 2vw;
	font-weight: bold;
}
.form-table {
  height: 20vw;
  border: 1px solid black;
  padding: 1vw;
}
.form-table table {
	margin: 0 auto;
}
.form-table table th {
  height: 3vw;
  text-align: right;
}
input {
  width: 20vw;
  font-size: 1.2vw;
  padding-left: 5px;
}
.signin-btn {
  position: relative;
  bottom: -7vw;
  background-color: #AF9453;
  color: white;
  margin-top: 0.5vw;
  padding: 1.5vw 4vw;
}

</style>
